import React from "react";

const LinkToModal = ({ children, href, disabled, className = "", options = {} }) => {
  let dataOptions = {
    "data-save-label": options.save_label || I18n.t("save"),
    "data-title": options.title,
  };

  if (options.buttons == false) {
    dataOptions["data-hide-buttons"] = true;
  }

  if (options.hideSaveButton) {
    dataOptions["data-hide-save-button"] = true;
  }

  if (options.size) {
    dataOptions["data-modal-class"] = `modal-${options.size}`;
  }

  if (options.style) {
    dataOptions["data-modal-style"] = options.style;
  }

  return disabled ? (
    <span className={`disabled ${className}`}>{children}</span>
  ) : (
    <a href={href} className={`modal-dialog-link ${className}`} data-turbo={false} {...dataOptions}>
      {children}
    </a>
  );
};

export { LinkToModal };
